export const GET_TEASER_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    teaserBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      heading
      text
      externalLink
      globalLinkItem
      linkText
      useButtonLink
      isCampaignTeaser
      listedItems {
        ... on TextList {
          sys {
            id
          }
          listStyle
          texts
        }
      }
      backgroundColor
      ivImage
      isReverse
      link{
        ... on Page {
          slug
          content {
            __typename
          }
        }
        ... on FileBlock {
          imageVaultFile
          metaData
          __typename
        }
      }
      audienceCollection{
        items{
            __typename
            sys{id}
            audianceId
          }
      }
    }
  }
`;
